import { render, staticRenderFns } from "./OrderUnderStockNewForTab.vue?vue&type=template&id=f8ede13c"
import script from "./OrderUnderStockNewForTab.vue?vue&type=script&lang=js"
export * from "./OrderUnderStockNewForTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports